import { render, staticRenderFns } from "./agree.vue?vue&type=template&id=8d24e2a2"
import script from "./agree.vue?vue&type=script&lang=js"
export * from "./agree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports